import React from 'react';

interface FupSelProps {
  width?: number;
  height?: number;
}

const FupSel: React.FC<FupSelProps> = ({ width = 80, height = 70 }) => (
  <svg width={width} height={height} viewBox="0 0 80 70" xmlns="http://www.w3.org/2000/svg">
    {/* Baustein-Körper (Trapez) */}
    <path d="M 10 10 L 60 10 L 70 60 L 10 60 Z" fill="#E8F4F8" stroke="#0D3559" strokeWidth="2" />
    
    {/* Eingangs-Ankerpunkte */}
    <circle cx="5" cy="15" r="3" fill="#0D3559" />
    <circle cx="5" cy="35" r="3" fill="#0D3559" />
    <circle cx="5" cy="55" r="3" fill="#0D3559" />
    
    {/* Ausgangs-Ankerpunkt */}
    <circle cx="75" cy="35" r="3" fill="#0D3559" />
    
    {/* Labels */}
    <text x="15" y="20" fontSize="10" fill="#0D3559" fontWeight="bold">G</text>
    <text x="15" y="40" fontSize="10" fill="#0D3559" fontWeight="bold">IN0</text>
    <text x="15" y="60" fontSize="10" fill="#0D3559" fontWeight="bold">IN1</text>
    <text x="40" y="40" fontSize="12" fill="#0D3559" textAnchor="middle" fontWeight="bold">SEL</text>
  </svg>
);

export default FupSel;
